import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
import { billAutomationBillsRoutes, billingDashboardBaseUrl } from './routes';

/**
 * Dashboard bulk upload: up to ten files, each landing as its own bill. `propertyIds` may be omitted
 * (every property is resolved from the bill), hold one id for the whole batch, or hold exactly one id
 * per file, paired by position.
 */

/** Outcome of one file in a batch: `billId` is null when it was a duplicate or failed to land. */

/** One row of the billing dashboard list. Dates are date-only strings (YYYY-MM-DD). */

/** Status envelope returned by POST /bills and GET /bills/{billId}. */

export class BillAutomationBills {
  constructor() {
    _defineProperty(this, "routes", billAutomationBillsRoutes);
  }
  async startBill(data, options) {
    const formData = new FormData();
    formData.append('PropertyId', data.propertyId);
    formData.append('File', data.file);
    const appendList = (key, value) => {
      if (!value) return;
      const list = Array.isArray(value) ? value : [value];
      list.filter(Boolean).forEach(item => formData.append(key, item));
    };
    appendList('UtilityNames', data.utilityNames);
    if (data.propertyAddress) formData.append('PropertyAddress', data.propertyAddress);
    appendList('RequiredUtilities', data.requiredUtilities);
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).post(this.routes.baseUrl, formData, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBill(billId, options) {
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).get(this.routes.billById(billId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Lands every file as a Pending bill; per-file outcomes come back in the response array. */
  async uploadBillsBatch(data, options) {
    var _data$propertyIds;
    const formData = new FormData();
    data.files.forEach(file => formData.append('Files', file));
    ((_data$propertyIds = data.propertyIds) !== null && _data$propertyIds !== void 0 ? _data$propertyIds : []).forEach(propertyId => formData.append('PropertyIds', propertyId));
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).post(this.routes.companyBillsBatch(data.companyId), formData, _objectSpread({
      baseURL: billingDashboardBaseUrl
    }, options.cancelToken));
    return resp.data;
  }
  async getCompanyBills(data, options) {
    var _data$page, _data$pageSize;
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).get(this.routes.companyBills(data.companyId), _objectSpread({
      baseURL: billingDashboardBaseUrl,
      params: {
        page: (_data$page = data.page) !== null && _data$page !== void 0 ? _data$page : 1,
        pageSize: (_data$pageSize = data.pageSize) !== null && _data$pageSize !== void 0 ? _data$pageSize : 100
      }
    }, options.cancelToken));
    return resp.data;
  }
}